
<template>
	<div id="app">
		<transition name="van-fade" mode="out-in">
			<keep-alive>
				<router-view :key="key" v-if="keepAlive" />
			</keep-alive>
		</transition>
		<transition name="van-fade" mode="out-in">
			<router-view :key="key" v-if="!keepAlive" />
		</transition>
		<div class="back_icon" v-if="isWx&&type.isAndroid" v-drag @click.prevent="$router.go(-1)">
			<img src="@/assets/img/back.png" alt="" />
		</div>
	</div>
</template>

<script>
export default {
    data () {
        return {
            wxConfig: false,
            isWx: false,
            type: {}
        }
    },
    created () {
        // 判断是否在微信环境
        // eslint-disable-next-line no-undef
        var ua = navigator.userAgent.toLowerCase();
        var isWeixin = ua.indexOf('micromessenger') != -1;
        if (isWeixin) {
            this.isWx = true
        }
        // 如果没有患者id 就清空 token
        if (!this.$store.getters['account/getPatientId']) {
            this.$store.commit('account/SET_TOKEN', null)
        }
    },
    directives: {
        drag (el) {
            el.ontouchstart = e => {
                //算出鼠标相对元素的位置
                el.style.transition = 'none'
                const disX = e.touches[0].clientX - el.offsetLeft
                const disY = e.touches[0].clientY - el.offsetTop
                el.ontouchmove = e => {
                    e.preventDefault()
                    //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                    let left = e.touches[0].clientX - disX
                    let top = e.touches[0].clientY - disY
                    if (left < 0) left = 0
                    if (top < 0) top = 0
                    //移动当前元素
                    el.style.right = window.innerWidth - left - el.offsetWidth + 'px'
                    el.style.bottom = window.innerHeight - top - el.offsetHeight + 'px'
                }
                el.ontouchend = () => {
                    el.style.transition = 'all .3s ease-out'
                    el.style.right = ''
                    if (Number.parseFloat(el.style.bottom) < window.innerHeight - (window.innerHeight - el.offsetHeight - 50)) {
                        el.style.bottom = ''
                    }
                    if (Number.parseFloat(el.style.bottom) > (window.innerHeight - el.offsetHeight - 50)) {
                        el.style.bottom = window.innerHeight - el.offsetHeight - 50 + 'px'
                    }
                    el.ontouchmove = null
                    el.ontouchend = null
                }
            }
        }
    },
    computed: {
        key () {
            return this.$route.fullPath
        },
        keepAlive () {
            return this.$route.meta && this.$route.meta.keepAlive
        },
        name () {
            return this.$route.name
        }
    },
    watch: {
        name () {
            if (!this.wxConfig && ['joinTean', 'joinTeanSuccess', 'DpBindPatientResultShow'].indexOf(this.$route.name) == -1) {
                this.$wx.setConfigParams().then(_this => _this.config())
            }
        }
    },
    mounted () {
        this.type = this.$utils.phoneType()
    }
}
</script>
<style lang="less" scoped>
.back_icon {
	width: 110px;
	height: 110px;
	position: fixed;
	bottom: 200px;
	right: 48px;
	z-index: 999;
	img {
		width: 110px;
		height: 110px;
	}
}
</style>
